import React from 'react';
import { createRoot } from 'react-dom/client';
import ScheduleApp from './schedule/ScheduleApp';
import './legacy-global.css';
import reportWebVitals from './reportWebVitals';
import FormAdmin from './components/adminPage';

// Calendario publico: shortcode [calendarioTCBE] -> <div id="calendarioTCBE">
const calendarioTCBEElement = document.getElementById('calendarioTCBE');
if (calendarioTCBEElement) {
  createRoot(calendarioTCBEElement).render(<ScheduleApp />);
}

// Panel administrativo (pantalla "Tcbe Api Horarios")
const formularioAdminElement = document.getElementById('formularioAdmin');
if (formularioAdminElement) {
  createRoot(formularioAdminElement).render(<FormAdmin />);
}

reportWebVitals();
